// Recovered compiled webpack factory 61489. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      handleHardNavError: function () {
        return a;
      },
      useNavFailureHandler: function () {
        return o;
      },
    }),
    r(12115));
  let n = r(29658);
  function a(e) {
    return (
      !!e &&
      !!window.next.__pendingUrl &&
      (0, n.createHrefFromUrl)(new URL(window.location.href)) !==
        (0, n.createHrefFromUrl)(window.next.__pendingUrl) &&
      (console.error("Error occurred during navigation, falling back to hard navigation", e),
      (window.location.href = window.next.__pendingUrl.toString()),
      !0)
    );
  }
  function o() {}
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
